$(document).ready(function() {
  function selectTab(e) {
    e.preventDefault();

    var $this = $(this);
    var tabId = $this.attr('data-tab');

    var itemIndex = Array.from($tabItems).findIndex(function(item) {
      return $(item).attr('data-tab') === tabId;
    });

    $tabPill.css({
      '-webkit-transform:': 'translateX(' + (itemIndex * 100) + '%)',
      'transform': 'translateX(' + (itemIndex * 100) + '%)'
    })

    // Add "is-active" class to the selected tab
    $tabItems.removeClass('is-active');
    $this.addClass('is-active');

    // Add "is-active" class to the selected tab's content
    $('.js-tab-content').removeClass('is-active');
    $('.js-tab-content[data-tab="'+ tabId +'"]').addClass('is-active');
  }

  var $tabs = $('.js-tabs');

  if ($tabs.length) {
    var $tabPill = $tabs.find('.js-tab-pill');
    var $tabItems = $tabs.find('.js-tab-btn');

    if ($tabItems.length) {
      $tabItems.on('click', selectTab);
    }
  }
});
